/* Progressive enhancement: native category anchors and order links work without JS. */
(() => {
  document.querySelectorAll('.location-menu').forEach(root => {
    if (root.dataset.browseReady) return;
    root.dataset.browseReady = 'true';
    const nav = root.querySelector('.location-menu__nav');
    const groups = [...root.querySelectorAll('.location-menu__group')];
    const links = [...root.querySelectorAll('.location-menu__nav a')];
    const bar = root.querySelector('.location-menu__mobile-order');
    const topActions = root.querySelector('.location-menu__actions--top');
    const bottomActions = root.querySelector('.location-menu__actions:not(.location-menu__actions--top)');
    if (!nav) return;
    const rail = nav.querySelector('.location-menu__nav-links');
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    let activeId;
    let railWidth = 0;
    let pending = false;
    const update = () => {
      pending = false;
      const header = document.querySelector('.header-wrapper--sticky');
      const rect = header?.getBoundingClientRect();
      const offset = rect && rect.top <= 0 && rect.bottom > 0 ? rect.bottom : 0;
      root.style.setProperty('--menu-header-offset', `${Math.ceil(offset)}px`);
      const scrollPadding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
      root.style.setProperty('--menu-anchor-offset', `${Math.max(0, nav.offsetHeight + 16 - scrollPadding)}px`);
      const edge = offset + nav.offsetHeight + 28;
      let active = groups[0];
      for (const group of groups) if (group.getBoundingClientRect().top <= edge) active = group;
      links.forEach(link => {
        if (link.hash === `#${active?.id}`) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      // Move only the category rail, never the page or keyboard focus. Recheck
      // on a section change or resize so manual sideways browsing stays usable.
      if (rail && (activeId !== active?.id || railWidth !== rail.clientWidth)) {
        const current = links.find(link => link.hash === `#${active?.id}`);
        const bounds = rail.getBoundingClientRect();
        const item = current?.getBoundingClientRect();
        if (item && (item.left < bounds.left + 8 || item.right > bounds.right - 8)) {
          rail.scrollTo({
            left: rail.scrollLeft + item.left - bounds.left - (rail.clientWidth - item.width) / 2,
            behavior: reducedMotion.matches ? 'instant' : 'smooth'
          });
        }
        activeId = active?.id;
        railWidth = rail.clientWidth;
      }
      if (bar) bar.hidden = !(topActions?.getBoundingClientRect().bottom < 0 && bottomActions?.getBoundingClientRect().top > innerHeight - 90);
    };
    const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
    links.forEach(link => link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = groups.find(group => link.hash === `#${group.id}`);
      if (!target) return;
      event.preventDefault();
      history.pushState(null, '', link.hash);
      target.focus({preventScroll: true});
      window.scrollTo({top: scrollY + target.getBoundingClientRect().top - nav.offsetHeight - 16, behavior: 'instant'});
      requestAnimationFrame(() => {
        update();
        window.scrollBy({top: target.getBoundingClientRect().top - nav.getBoundingClientRect().bottom - 16, behavior: 'instant'});
        update();
      });
    }));
    addEventListener('scroll', schedule, {passive: true});
    addEventListener('resize', schedule, {passive: true});
    root.querySelector('details')?.addEventListener('toggle', schedule);
    update();
  });
})();
